(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sobo-announcement')) {
  customElements.define('sobo-announcement', class extends HTMLElement {
    connectedCallback() {
      this.messages = this.querySelectorAll('[data-announcement-message]');
      this.button = this.querySelector('button');
      if (this.messages.length < 2 || !this.button) return;
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.button.hidden = false;
      this.toggle = () => { this.paused = !this.paused; this.update(); };
      this.motionChanged = () => { this.paused = this.motion.matches; this.update(); };
      this.button.addEventListener('click', this.toggle);
      this.motion.addEventListener('change', this.motionChanged);
      this.update();
    }
    update() {
      clearInterval(this.timer);
      this.button.setAttribute('aria-label', this.paused ? this.button.dataset.resume : this.button.dataset.pause);
      this.button.textContent = this.paused ? '▶' : 'Ⅱ';
      if (!this.paused) this.timer = setInterval(() => {
        this.messages[this.index].hidden = true;
        this.index = (this.index + 1) % this.messages.length;
        this.messages[this.index].hidden = false;
      }, 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.button) this.button.removeEventListener('click', this.toggle);
      if (this.motion) this.motion.removeEventListener('change', this.motionChanged);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
